import { MESSAGE, NOTIFICATION, PROFILE_ACTIVE, SETTINGS_ACTIVE, SIDEBAR_ACTIVE, THEME } from "../types/styles";

const initialState = {
  sidebarActive: false,
  settingsActive: false,
  profileActive: false,
  darkTheme: false,
  notification: { visible: false, text: "Successfull", type: "success" },
  message: null,
};

const stylesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SIDEBAR_ACTIVE:
      return { ...state, sidebarActive: payload };
    case SETTINGS_ACTIVE:
      return { ...state, settingsActive: payload };
    case PROFILE_ACTIVE:
      return { ...state, profileActive: payload };
    case THEME:
      return { ...state, darkTheme: payload };
    case NOTIFICATION:
      return { ...state, notification: payload };
    case MESSAGE:
      return { ...state, message: payload };
    default:
      return state;
  }
};

export default stylesReducer;
